/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { Map, Marker, Polygon, TileLayer } from 'react-leaflet';
import L from 'leaflet';

const enhance = compose(translate(['geozones'], { wait: true }));

const tileUrl = L.Browser.retina
  ? 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}@2x.png'
  : 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}.png';

const icon = L.divIcon({
  html: '<div class="dot-region"></div>',
});

export const GeozoneItem = enhance(({ geozone, t, onDelete, onEdit, onActivate }) => {
  const points = geozone.wkt.split('((')[1].split('))')[0].split(',').map((item) => {
    const trimmed = item.trim();
    return {
      lat: parseFloat(trimmed.split(' ')[1]),
      lng: parseFloat(trimmed.split(' ')[0]),
    };
  });
  points.splice(points.length - 1, 1);
  const position = [(points[0].lat + points[points.length - 1].lat) / 2, (points[0].lng + points[points.length - 1].lng) / 2];

  const enabled = geozone.isEnabled;

  return (<li className="garage-list__item">
    <div className="garage-region">
      <div className="garage-region__map">
        <Map
          center={{ lat: position[0], lng: position[1] }}
          zoom={11}
          zoomControl={false}
          style={{ height: '100%', width: '100%' }}
          dragging={false}
          doubleClickZoom={false}
          scrollWheelZoom={false}
          attributionControl={false}
        >
          <TileLayer detectRetina url={tileUrl}/>
          <Polygon positions={points} />
          {points.map(point => (<Marker
            key={point.lat.toString() + point.lng.toString()}
            icon={icon}
            position={[point.lat, point.lng]}
          />))}
        </Map>
      </div>
      <div className="garage-region__content">
        <div className="garage-region__description">
          <h3 className="garage-region__title" onClick={onEdit}>{geozone.name}</h3>
          <label className="switch">
            <input type="checkbox" checked={enabled} onChange={onActivate} />
            <span className="slider" />
            <span className="switch__text" data-on-text={t('geozones:active')} data-off-text={t('geozones:non-active')} />
          </label>
        </div>
        <footer className="garage-region__action">
          <a role="presentation" onClick={onDelete} className="link link_action_remove">{t('geozones:new-geozone__remove')}</a>
        </footer>
      </div>
    </div>
  </li>);
},
);

GeozoneItem.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onActivate: PropTypes.func.isRequired,
  geozone: PropTypes.shape({
    name: PropTypes.string,
    wkt: PropTypes.string,
    isEnabled: PropTypes.bool,
  }).isRequired,
};

GeozoneItem.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/Geozones/GeozoneItem.js